import { render, staticRenderFns } from "./HeaderTop.vue?vue&type=template&id=b638b96a"
import script from "./HeaderTop.vue?vue&type=script&lang=js"
export * from "./HeaderTop.vue?vue&type=script&lang=js"
import style0 from "./HeaderTop.vue?vue&type=style&index=0&id=b638b96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports